import Dexie from "dexie";
import db from "../Db";

var DeleteLigneAction = Dexie.async(function* () {
  yield db.open();
  yield db.LIGNE_ACTION.clear();
});

export default DeleteLigneAction;
